import { render, staticRenderFns } from "./LeicesterResources.vue?vue&type=template&id=3e623c0d&"
import script from "./LeicesterResources.vue?vue&type=script&lang=js&"
export * from "./LeicesterResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports